/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Oktaacccreateemailmissing4Inputs */

const en_auth_oktaacccreateemailmissing4 = /** @type {(inputs: Auth_Oktaacccreateemailmissing4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is missing`)
};

/**
* | output |
* | --- |
* | "Email is missing" |
*
* @param {Auth_Oktaacccreateemailmissing4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_oktaacccreateemailmissing4 = /** @type {((inputs?: Auth_Oktaacccreateemailmissing4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Oktaacccreateemailmissing4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_oktaacccreateemailmissing4(inputs)
});
export { auth_oktaacccreateemailmissing4 as "auth_oktaAccCreateEmailMissing" }